import { isPatientMode } from '../../../../platform/app/src/custom/utils/patientMode';

async function getStudiesForPatientByMRN(dataSource, qidoForStudyUID) {
  if (!qidoForStudyUID?.length) {
    return [];
  }

  const mrn = qidoForStudyUID[0].mrn;

  // if not defined or empty, return the original qidoForStudyUID
  if (!mrn) {
    return qidoForStudyUID;
  }

  const searchParams = {
    patientId: mrn,
    disableWildcard: true,
  };

  // Patient logins may only access their assigned study, not prior studies for comparison.
  if (isPatientMode() && qidoForStudyUID[0].studyInstanceUid) {
    searchParams.studyInstanceUid = qidoForStudyUID[0].studyInstanceUid;
  }

  return dataSource.query.studies.search(searchParams);
}

export default getStudiesForPatientByMRN;
